import { PersonCard } from '../Templates';

class People {
    constructor() {
        this.viewmore = document.querySelector('.people__list--link');
        this.peoplelist = document.querySelector('.people__list');
        this.page = 1;

        this.events();
        this.loadnext();
    }

    events() {
        this.viewmore.addEventListener('click', this.loadnext.bind(this));
    }

    loadnext() {
        const url = `/person-api/get_people/${this.page}`;

        fetch(url,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-requested-with': 'XMLHttpRequest'
                },
                method: 'GET',
            })
        .then(response => response.json())
        .then(data => {
            if(!data.showmore) {
                this.viewmore.style.visibility = "hidden";
            }

            this.peoplelist.innerHTML += this.buildPeopleList(data.people);
            this.page++;
        })
    }

    buildPeopleList(json_data) {
        return json_data.map(data => PersonCard(data, 'fg')).join('');
    }
}

export default People;
